// import * as filestack from 'filestack-js'
interface FilestackImageFormat {
  handle: string
  height?: number
  width?: number
  density?: number[]
}

const processUrl = 'https://process.filestackapi.com'
const resizePolicy = import.meta.env.VITE_FILESTACK_CDN_RESIZE_POLICY
const resizeSignature = import.meta.env.VITE_FILESTACK_CDN_RESIZE_SIGNATURE

export const cdnUrl = 'https://cdn.filestackcontent.com/'
export const imageComingSoon = 'GmSV395qTKCo08SAQjgA'
export const publicReadPolicy = `?policy=${resizePolicy}&signature=${resizeSignature}`

const FilestackService = {
  getProductImage: (payload: FilestackImageFormat): string => {
    const {
      handle = imageComingSoon,
      height = 400,
      width = null,
      density = 40
    } = payload
    // Default for image previews
    return `${processUrl}/security=p:${resizePolicy},s:${resizeSignature}/resize=height:${height}${width ? `,width:${width},fit:max` : ''}/output=format:jpg,density:${density}/${handle}`
  },
  cdnUrl,
  publicReadUrl: (handle: string) => {
    // best for non-image files like pdf datasheets
    return `${FilestackService.cdnUrl}${handle}${publicReadPolicy}`
  },
  filestackPdfPreview: (handle: string) => {
    return `${processUrl}/security=p:${resizePolicy},s:${resizeSignature}/output=format:png,density:40/${handle}`
  }
}

export default FilestackService
